<footer class="dashboard-layout">
    <ng-content></ng-content>
</footer>
